import { SiteProvider } from './lib/site-context.jsx';
import { Header } from './ui/Header.jsx';
import { Footer } from './ui/Footer.jsx';
import { FloatingActions } from './ui/FloatingActions.jsx';
import Home from './pages/Home.jsx';
import Projects from './pages/Projects.jsx';
import Project from './pages/Project.jsx';
import { Blog, BlogPost } from './pages/Blog.jsx';
import Contact from './pages/Contact.jsx';
import Compare from './pages/Compare.jsx';
import Visit from './pages/Visit.jsx';
import { Privacy, Terms } from './pages/Legal.jsx';
import Raw from './pages/Raw.jsx';
import NotFound from './pages/NotFound.jsx';

const PAGES = {
  home: Home, projects: Projects, project: Project, blog: Blog, 'blog-post': BlogPost, contact: Contact,
  compare: Compare, visit: Visit, privacy: Privacy, terms: Terms, raw: Raw, 'not-found': NotFound,
};

// boot: { route, path, settings, year, nav, footerLinks, data } from the server.
export default function App({ boot }) {
  const Page = PAGES[boot.route] || NotFound;
  return (
    <SiteProvider boot={boot}>
      {boot.draft && <div className="draft-banner" role="status">Draft preview · only you can see this, it is not on your website yet</div>}
      <a className="skip-link" href="#main">Skip to content</a>
      <Header />
      <main id="main" tabIndex={-1} className={`page page-${boot.route}`}>
        <Page data={boot.data || {}} />
      </main>
      <Footer />
      <FloatingActions />
    </SiteProvider>
  );
}
